import "./About.style.css";
import Image from "../../assets/Nikola.png";
import { IoIosArrowForward } from "react-icons/io";
import dayjs from "dayjs";
const About = () => {
  return (
    <section className="section-title section-container" id="about">
      <h2>About</h2>
      <p className="about-me-paragraph">
        I'm Nikola Ristoski bachelor of Informatics and Full Stack JavaScript
        Developer located in Skopje, Macedonia.
      </p>
      <p className="about-me-paragraph">
        I am passionate about Web development and learning new technologies,
        also i am proactive, fast learner and motivated Team Player eager and
        excited to learn from industry experts. Interested in the entire Web
        Development spectrum and working on ambitious projects with positive
        people.
      </p>
      <div className="about-container">
        <div className="user-section-image">
          <img src={Image} alt="userImage" />
        </div>
        <div className="about-me-container">
          <h3>Full-stack Web developer</h3>
          <div className="ul-lists-container">
            <ul>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Birthday:</strong>
                <span>29.05.1992</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Website:</strong>
                <span>https://nikolaristoski.netlify.app/</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <b>Phone:</b>
                <span>+389 00 000 000</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>City:</strong>
                <span>Skopje</span>
              </li>
            </ul>
            <ul>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Age:</strong>
                <span>{dayjs(new Date()).diff("1992-05-29", "year")}</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Degree:</strong>
                <span>Bachelor's</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Email:</strong>
                <span>ristoski.nikola@gmail.com</span>
              </li>
              <li>
                <span className="icon">
                  <IoIosArrowForward />
                </span>
                <strong>Freelance:</strong>
                <span>Available</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
